import { API } from 'aws-amplify';

const migrateTeam = async data => {
  const newTeam = await API.post('agentbuzz', 'mteams', {
    body: migrateTeamData(data),
  });
  return newTeam;
};

const migrateTeamData = data => {
  const teamData = {
    planId: data.plan,
    s_customerId: data.customerId,
    listingsAllowed: data.listingsAllowed,
    localPhoneNumber: data.localPhoneNumber,
  };
  return teamData;
};

export default migrateTeam;



// WEBPACK FOOTER //
// ./src/services/team/migrateTeam.js